import { render, staticRenderFns } from "./PageContentSkeleton.vue?vue&type=template&id=62fe00dc&scoped=true"
import script from "./PageContentSkeleton.vue?vue&type=script&lang=js"
export * from "./PageContentSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fe00dc",
  null
  
)

export default component.exports